import React, { Component } from "react";
import { Grid, Header, Button, Transition } from 'semantic-ui-react';

class Step3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      animation: props.animation
    };

    this.transitionBack = this.transitionBack.bind(this);
    this.transitionNext = this.transitionNext.bind(this);

  }

  componentDidMount() {
    this.setState({
      visible: true
  });
 }

 transitionBack()
 {
  const {  changeStep } = this.props;

  this.setState({
    animation: "fade left",
    visible: false
  });
  setTimeout(() => {
    changeStep(2, "fade right")
  }, 400);
 }

 transitionNext()
 {
  const { changeStep } = this.props;

    this.setState({
      animation: "fade right",
      visible: !this.state.visible
    });
    setTimeout(() => {
      changeStep(4, "fade left")
    }, 400);
 }

  render() {
    const { visible, animation } = this.state;

    return <div>
      <div className="back--icon" onClick={this.transitionBack}></div>
      <Transition visible={visible} duration={500} animation={animation}>
        <div>
          <Header className='title__main' as='h1' textAlign='center'>Schedule Installation
          </Header>
          <Header.Subheader className='text-black'>We will contact you within 1-2 business days to schedule.</Header.Subheader>
          <Grid className='form__signup width__xs'>
            <Grid.Row className="py-0">
              <Grid.Column className="px-0">
                <Button className='btn--full' type="button" size='medium' onClick={this.transitionNext}>My Account</Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </Transition>
    </div>
  };
}

export default Step3;


// WEBPACK FOOTER //
// ./src/components/check-availability/service-not-available/Step3.js